import { render, staticRenderFns } from "./CreateWalletType.vue?vue&type=template&id=2834ee85&"
import script from "./CreateWalletType.vue?vue&type=script&lang=js&"
export * from "./CreateWalletType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports